import React, { lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ArtistRouter from './ArtistRouter';
import AdminRouter from './AdminRouter';
import RoleDashboardRouter from './RoleDashboardRouter';
import RoleAnalyticsRouter from './RoleAnalyticsRouter';
import RoleEmailsRouter from './RoleEmailsRouter';
// Affiliate UI lives in starfarm-admin; routes disabled here to avoid duplication.
// import AffiliateLanding from 'pages/affiliate/AffiliateLanding';

// Authentication pages
const LoginPage = lazy(() => import('pages/Login/LoginPage'));
const Registration = lazy(() => import('pages/Registration/Registration'));
const ForgotPassword = lazy(() => import('pages/ForgotPassword'));
const ResetPassword = lazy(() => import('pages/ResetPassword'));
const BeneficiaryInviteAccept = lazy(() => import('pages/BeneficiaryInviteAccept'));

// Affiliate pages — disabled; use starfarm-admin for affiliate features
// const AffiliateDashboard = lazy(() => import('pages/affiliate/AffiliateDashboard'));
// const AffiliateConversions = lazy(() => import('pages/affiliate/AffiliateConversions'));
// const AffiliateProfile = lazy(() => import('pages/affiliate/AffiliateProfile'));

const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#02172a',
    color: '#fff'
  }}>
    <div>Loading...</div>
  </div>
);

const AppRouter: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Switch>
        {/* Affiliate UI lives in starfarm-admin; redirect any /affiliate/* to login */}
        <Route exact path="/affiliate/landing" render={() => <Redirect to="/login" />} />
        <Route exact path="/affiliate/dashboard" render={() => <Redirect to="/login" />} />
        <Route exact path="/affiliate/conversions" render={() => <Redirect to="/login" />} />
        <Route exact path="/affiliate/profile" render={() => <Redirect to="/login" />} />

        {/* Public authentication routes */}
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/register" component={Registration} />
        <Route exact path="/registration" component={Registration} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/reset-password" component={ResetPassword} />
        <Route exact path="/beneficiary/invite/accept" component={BeneficiaryInviteAccept} />

        {/* Admin routes */}
        <Route path="/admin" component={AdminRouter} />
        <Route path="/superadmin" component={AdminRouter} />
        <Route path="/analytics" component={RoleAnalyticsRouter} />
        <Route path="/emails" component={RoleEmailsRouter} />
        
        {/* Legacy unauthenticated route - redirect to login */}
        <Route exact path="/unauthenticated" render={() => <Redirect to="/login" />} />
        
        {/* Root path - redirect to login */}
        <Route exact path="/" render={() => <Redirect to="/login" />} />

        {/* Shared dashboard URL: admin vs artist/streamer (see RoleDashboardRouter) */}
        <Route path="/dashboard" component={RoleDashboardRouter} />
        
        {/* Protected artist routes */}
        <Route path="/" component={ArtistRouter} />
        
        {/* Fallback redirect */}
        <Redirect to="/login" />
      </Switch>
    </Suspense>
  );
};

export default AppRouter;
